import React from 'react'
import posts from 'virtual:latest-posts'
import './LatestPosts.css'

const dateFormat = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
})

const LatestPosts: React.FC = () => (
  <section id="blog" className="latest-posts-section">
    <div className="container">
      <div className="latest-posts-header text-center">
        <p className="section-subtitle">From the Blog</p>
        <h2 className="section-title">Ideas for a Better Day</h2>
        <p className="section-description">
          Short, practical reads on mindset, habits and small moments of positivity.
        </p>
      </div>

      <div className="latest-posts-grid">
        {posts.map((post) => (
          <a key={post.url} className="latest-post card" href={post.url}>
            <img
              className="latest-post-image"
              src={post.image}
              alt=""
              loading="lazy"
              width="1200"
              height="630"
            />
            <div className="latest-post-body">
              <time className="latest-post-date" dateTime={post.date}>
                {dateFormat.format(new Date(post.date))}
              </time>
              <h3 className="latest-post-title">{post.title}</h3>
              <p className="latest-post-description">{post.description}</p>
              <span className="latest-post-more">Read the article →</span>
            </div>
          </a>
        ))}
      </div>

      <div className="text-center">
        <a className="btn btn-secondary btn-medium" href="https://blog.makemyday.tips/blog/">
          <span>See all articles</span>
        </a>
      </div>
    </div>
  </section>
)

export default LatestPosts
